// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__ST5Gj","message":"index_message__Feh6y"};